import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-confirm-coupon',
  templateUrl: './confirm-coupon.component.html',
  styleUrls: ['./confirm-coupon.component.css']
})
export class ConfirmCouponComponent implements OnInit {

  year: string;
    type: string;
    message: string;
    error = false;
    response = false;

    constructor(
      private router: Router,
      private route: ActivatedRoute,
      private spinner: NgxSpinnerService,
    ) {
      this.loadScripts();
    }

    ngOnInit() {
      this.year = new Date().getFullYear().toString();
      this.spinner.show();

      this.type = this.route.snapshot.queryParamMap.get("type");
      this.message = this.route.snapshot.queryParamMap.get("message");

      if (
        this.type !== undefined &&
        this.type !== null &&
        this.type !== "" &&
        this.message !== undefined &&
        this.message !== null &&
        this.message !== ""
      ) {
        this.error = true;
        this.spinner.hide();
        // this.type = this.route.snapshot.queryParamMap.get("type");
        // this.message = this.route.snapshot.queryParamMap.get("message");
        console.log(this.type);
        console.warn(this.message);
      } else {
        this.error = false;
        this.spinner.hide();
        this.type = "error";
        this.message = "An error occurred, please try again.";
      }
    }

    loadScripts() {
      const dynamicScripts = [
        "assets/js/vendor/jquery-1.11.3.min.js",
        "assets/js/bootstrap.min.js",
        "assets/js/wow.min.js",
        "assets/js/jquery-price-slider.js",
        "assets/js/jquery.meanmenu.js",
        "assets/js/owl.carousel.min.js",
        "assets/js/jquery.sticky.js",
        "assets/js/jquery.scrollUp.min.js",
        "assets/js/scrollbar/jquery.mCustomScrollbar.concat.min.js",
        "assets/js/scrollbar/mCustomScrollbar-active.js",
        "assets/js/metisMenu/metisMenu.min.js",
        "assets/js/metisMenu/metisMenu-active.js",
        "assets/js/tab.js",
        "assets/js/icheck/icheck.min.js",
        "assets/js/icheck/icheck-active.js",
        "assets/js/plugins.js",
        "assets/js/main.js",
      ];
      // tslint:disable-next-line:prefer-for-of
      for (let i = 0; i < dynamicScripts.length; i++) {
        const node = document.createElement("script");
        node.src = dynamicScripts[i];
        node.type = "text/javascript";
        node.async = false;
        node.charset = "utf-8";
        document.getElementsByTagName("head")[0].appendChild(node);
      }
    }

}
